<template>
  <div id="searchFilter">
    <v-row>
      <v-col cols md="4">
        <div class="select-def">
          <v-select
            :items="appealTypes"
            item-value="id"
            item-text="transName"
            v-model="search.appealType"
            :placeholder="$t('Тип обращения')"
            :aria-label="$t('Тип обращения')"
            required
            outlined
            dense
            clearable
          />
        </div>
      </v-col>
      <v-col cols md="4">
        <div class="select-def">
          <v-select
            :items="appealStatuses"
            item-value="id"
            item-text="transName"
            v-model="search.appealStatus"
            :placeholder="$t('Статус обращения')"
            :aria-label="$t('Статус обращения')"
            required
            outlined
            dense
            clearable
          />
        </div>
      </v-col>
      <v-col cols md="4">
        <div class="select-def">
          <v-select
            :items="applicantTypes"
            item-value="id"
            item-text="transName"
            v-model="search.applicantType"
            :placeholder="$t('Вид заявителя')"
            :aria-label="$t('Вид заявителя')"
            required
            outlined
            dense
            clearable
          />
        </div>
      </v-col>
      <v-col
        v-if="user && (user.roleCoordinator === true || user.roleAdmin === true)"
        cols
        md="4"
      >
        <div class="select-def">
          <v-autocomplete
            :items="developers"
            item-value="id"
            item-text="transName"
            v-model="search.developer"
            :placeholder="$t('Разработчики')"
            :aria-label="$t('Разработчики')"
            required
            outlined
            dense
            clearable
          >
            <template v-slot:item="{ item }">
              <v-list-item-icon class="select-def__icon">
                <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small aria-hidden="true"/>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.transName }}
                </v-list-item-title>
                </v-list-item-content>
              </template>
          </v-autocomplete>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="form-action" cols sm="12" md>
        <button
          class="btn btn-default blue"
          @click=";(page = 1), searchAppeal()"
        >
          {{ $t('Поиск') }}
        </button>
        <button
          class="btn btn-default white"
          @click="resetAppeal()"
        >
          {{ $t('Очистить') }}
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      search: Object,
      user: Object,
      appealTypes: Array,
      applicantTypes: Array,
      appealStatuses: Array,
      developers: Array,
    },
    methods: {
      searchAppeal () {
        this.$emit('search-appeal', this.search)
      },
      resetAppeal () {
        this.$emit('reset-appeal', this.search)
      }
    }
  }
</script>
